export default __webpack_public_path__ + "static/media/intro-user.edd44853.png";